// Validação de CNPJ numérico ou alfanumérico (Nota Técnica RFB 2025.001).
// As 12 primeiras posições aceitam 0-9/A-Z; os 2 dígitos verificadores continuam
// sempre numéricos. O pacote `cpf_cnpj` (node_modules) só aceita dígitos, então o
// CNPJ passou a ser validado por este módulo — o CPF continua vindo de lá.

const BLACKLIST = [
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999',
]

const STRIP_REGEX = /[^0-9A-Za-z]/g

// Valor de cada caractere no cálculo do módulo 11 = código ASCII - 48
// (dígitos '0'-'9' mantêm o próprio valor; letras 'A'-'Z' valem 17-42).
const charValue = char => char.charCodeAt(0) - 48

const verifierDigit = digits => {
  let weight = digits.length - 7
  let sum = 0

  for (let i = 0; i < digits.length; i++) {
    sum += charValue(digits[i]) * weight
    weight = weight === 2 ? 9 : weight - 1
  }

  const mod = sum % 11
  return mod < 2 ? 0 : 11 - mod
}

const strip = number => (number || '').toString().toUpperCase().replace(STRIP_REGEX, '')

const isValid = number => {
  const stripped = strip(number)

  if (stripped.length !== 14) return false
  if (BLACKLIST.includes(stripped)) return false
  if (!/^[0-9]{2}$/.test(stripped.slice(12))) return false

  const base = stripped.slice(0, 12)
  const firstDigit = verifierDigit(base)
  const secondDigit = verifierDigit(base + firstDigit)

  return `${firstDigit}${secondDigit}` === stripped.slice(12)
}

const format = number => strip(number).replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5')

export const CNPJ = { isValid, strip, format }

export default CNPJ
